/* RESPONSIBLE TEAM: team-phone */
import Controller from '@ember/controller';

export default class CallingController extends Controller {
  queryParams = ['paywall'];

  paywall = false;
}
